import { Injectable, inject } from '@angular/core';

import { NotificationPayload } from '../models/notification.model';
import { ToastService } from '../ui/toast/toast.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private readonly toastService = inject(ToastService);

  success(message: string, title = 'Success'): void {
    this.toastService.show({ level: 'success', title, message });
  }

  error(message: string, title = 'Error'): void {
    this.toastService.show({ level: 'error', title, message });
  }

  warning(message: string, title = 'Warning'): void {
    this.toastService.show({ level: 'warning', title, message });
  }

  info(message: string, title = 'Info'): void {
    this.toastService.show({ level: 'info', title, message });
  }

  show(payload: NotificationPayload): void {
    this.toastService.show(payload);
  }
}
